import { CompactEncrypt, compactDecrypt } from 'jose';

let kwKeyPromise;

function getKwKey(isAPIHUB=false) {
    const SECRET = process.env.REACT_APP_BASESECRET ; // <-- sample
      
      if (!kwKeyPromise) {
        const raw = new TextEncoder().encode(SECRET).slice(0, 32); // ensure 32 bytes
        kwKeyPromise = crypto.subtle.importKey(
          'raw',
          raw,
          { name: 'AES-KW', length: 256 },
          false,
          ['wrapKey', 'unwrapKey']
        );
      }
      return kwKeyPromise;
    }
    export async function encryptApiHubData(data) {
      const key = await getKwKey(true);
      const payload = new TextEncoder().encode(JSON.stringify(data));
      const jwe = await new CompactEncrypt(payload)
        .setProtectedHeader({ alg: 'A256KW', enc: 'A256CBC-HS512' })
        .encrypt(key);
      return jwe; // compact JWE string
    }
    export async function decryptApiHubData(jweToken) {
        try {
          const key = await getKwKey(true);
          const { plaintext } = await compactDecrypt(jweToken, key);
          var res = JSON.parse(new TextDecoder().decode(plaintext))
          return res
        } catch (e) {
          return null;
        }
      }